export const ORDER_PPN_RECOMMENDATIONS_CACHE_KEY = "order-ppn-recommendations";
export const ORDER_STEDI_ELIGIBILITY_CHECK_CACHE_KEY = "order-stedi-eligibility-check";
